export default __webpack_public_path__ + "static/singingBowl-71d964e2f6227897ddfe1faf6b0109d8.jpg";